exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".settings-batch-loader {\n  margin-top: 12px;\n  font-size: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/batch/all/batch.all.scss
// module id = 958
// module chunks = 1